var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import operationCheckUtils from "@ane/exp-data/lib/utils/OperationCheckUtils";
import ___default from "lodash";
import { o as overrideActions } from "../../FeatureDataActions-59549dc8.js";
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
import { overrideUtilsInstance } from "../utils/OverrideUtils.js";
const getDefaultState = () => {
  return {
    overrideSets: []
  };
};
class OverrideReducer {
  resetOverrideActionsState(state) {
    return __spreadValues(__spreadValues({}, state), getDefaultState());
  }
  loadOverrideSetsForFeatureInternal(state, actionResult) {
    if (!actionResult.payload || !actionResult.payload.overrideSets || actionResult.payload.overrideSets.length === 0) {
      return getDefaultState();
    }
    const { overrideSets, mdsFilters } = actionResult.payload;
    let overrideReducerState = [];
    overrideSets.forEach((oSet, index) => {
      const currOverrideSet = overrideUtilsInstance.parseOverrideSet(oSet, mdsFilters);
      overrideReducerState[index] = {
        overrideSet: currOverrideSet,
        currentStage: overrideUtilsInstance.getFrontierStage(currOverrideSet.stages),
        nextStage: overrideUtilsInstance.getNextFrontierStage(currOverrideSet.stages)
      };
    });
    return { overrideSets: overrideReducerState };
  }
  loadOverrideSetInternal(state, actionResult) {
    const { overrideSet, mdsFilters } = actionResult.payload;
    const newOverrideSet = overrideUtilsInstance.parseOverrideSet(overrideSet, mdsFilters);
    let indexToUpdate = overrideUtilsInstance.getOverrideIndexToUpdate(state, newOverrideSet.id);
    const overrideReducerUpdatedState = ___default.cloneDeep(state);
    if (indexToUpdate === -1) {
      indexToUpdate = state.overrideSets.length;
    }
    overrideReducerUpdatedState.overrideSets[indexToUpdate] = {
      overrideSet: newOverrideSet,
      currentStage: overrideUtilsInstance.getFrontierStage(newOverrideSet.stages),
      nextStage: overrideUtilsInstance.getNextFrontierStage(newOverrideSet.stages)
    };
    return overrideReducerUpdatedState;
  }
  fetchOverrideOperationCheck(state, actionResult) {
    const indexToBeChecked = overrideUtilsInstance.getOverrideIndexToUpdate(state, actionResult.payload.id);
    const overrideReducerUpdatedState = state.overrideSets;
    if (!!overrideReducerUpdatedState[indexToBeChecked] && !!overrideReducerUpdatedState[indexToBeChecked].overrideSet && !!overrideReducerUpdatedState[indexToBeChecked].overrideSet.operationCheck) {
      overrideReducerUpdatedState[indexToBeChecked].overrideSet.operationCheck = operationCheckUtils.parseOperationCheckResponse(
        actionResult.payload,
        state.overrideSets[indexToBeChecked].overrideSet.operationCheck
      );
    }
    return __spreadProps(__spreadValues({}, state), {
      overrideSets: overrideReducerUpdatedState
    });
  }
  updateGates(state, actionResult) {
    const entityGateMapping = actionResult.payload;
    const newState = ___default.cloneDeep(state);
    state.overrideSets.forEach((oSet, index) => {
      newState.overrideSets[index].overrideSet.gates = {
        status: entityGateMapping.status,
        data: entityGateMapping.data && entityGateMapping.data[state.overrideSets[index].overrideSet.id]
      };
    });
    return newState;
  }
}
const reducer = createReducer(overrideActions, new OverrideReducer(), getDefaultState());
export {
  OverrideReducer,
  reducer as default
};
//# sourceMappingURL=OverrideReducer.js.map
